function renderBuildGroupCreatableSelectHandlersCurrentValueTemplate({
  fieldName,
  defaultValueFromHandlerContent
}: {
  fieldName: string
  defaultValueFromHandlerContent: string
}): string {
  return `const currentValue = form.getValues('${fieldName}')
      const selectedValues = Array.isArray(currentValue) ? currentValue : []
      const nextValues = [...new Set([...selectedValues, result.option.value])]
      ${defaultValueFromHandlerContent}form.setValue('${fieldName}', nextValues, {
        shouldDirty: true,
        shouldValidate: true
      })`
}

function renderBuildGroupCreatableSelectHandlersContentTemplate({
  defaultValueFromHandlerContent,
  fieldName
}: {
  defaultValueFromHandlerContent: string
  fieldName: string
}): string {
  return `${defaultValueFromHandlerContent}form.setValue('${fieldName}', result.option.value, {
        shouldDirty: true,
        shouldValidate: true
      })`
}

function renderBuildGroupCreatableSelectHandlersTrimmedLabelTemplate({
  fieldPascal,
  singular,
  fieldName,
  schemaName,
  setCreatedOptionValue
}: {
  fieldPascal: string
  singular: string
  fieldName: string
  schemaName: string
  setCreatedOptionValue: string
}): string {
  return `  function handleCreate${fieldPascal}Option(label: string) {
    const trimmedLabel = label.trim()
    if (!trimmedLabel) return

    startCreate${fieldPascal}OptionTransition(async () => {
      const result = await create${singular}SelectOption({
        fieldName: '${fieldName}',
        label: trimmedLabel
      })

      if (!result.success || !result.option) {
        toast.error(result.error || 'Failed to create option')
        return
      }

      await queryClient.invalidateQueries({
        queryKey: ['${schemaName}', 'select-options', '${fieldName}']
      })
      ${setCreatedOptionValue}
      set${fieldPascal}Search('')
      set${fieldPascal}Open(false)
      toast.success('Option created')
    })
  }`
}

export function renderSingleFormBuildGroupCreatableSelectHandlersRenderer(
  request:
    | {
        kind: 'renderBuildGroupCreatableSelectHandlersCurrentValueTemplate'
        props: {
          fieldName: string
          defaultValueFromHandlerContent: string
        }
      }
    | {
        kind: 'renderBuildGroupCreatableSelectHandlersContentTemplate'
        props: {
          defaultValueFromHandlerContent: string
          fieldName: string
        }
      }
    | {
        kind: 'renderBuildGroupCreatableSelectHandlersTrimmedLabelTemplate'
        props: {
          fieldPascal: string
          singular: string
          fieldName: string
          schemaName: string
          setCreatedOptionValue: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderBuildGroupCreatableSelectHandlersCurrentValueTemplate':
      return renderBuildGroupCreatableSelectHandlersCurrentValueTemplate(request.props)
    case 'renderBuildGroupCreatableSelectHandlersContentTemplate':
      return renderBuildGroupCreatableSelectHandlersContentTemplate(request.props)
    case 'renderBuildGroupCreatableSelectHandlersTrimmedLabelTemplate':
      return renderBuildGroupCreatableSelectHandlersTrimmedLabelTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
